import { STEP } from "#src/constants/step.ts";
import { defineStore } from "#src/stores/state-wrapper.ts";
import { useFlowStore } from "#src/stores/flow.ts";
import { useStepNameStore } from "#src/stores/step-name.ts";
import { type Pinia, type StoreGeneric } from "pinia";
import { computed, type ComputedRef } from "vue";
import { type BaseStepStore } from "#src/types/StepStore.ts";

interface DemoStep extends BaseStepStore {
  inactive: ComputedRef<boolean>;
}

function initializeDemoStep(pinia: Pinia): DemoStep {
  const step = computed(() => STEP.DEMO);
  const previous = computed(() => null);
  const next = computed(() => {
    const name = useStepNameStore(pinia);
    return name.step;
  });
  const inactive = computed(() => {
    const flow = useFlowStore(pinia);
    return flow.initialStepIsDemo;
  });
  const skipStepSave = computed(() => true);

  function $reset() {}

  return {
    $reset,
    step,
    previous,
    next,
    inactive,
    skipStepSave,
  };
}
export const useStepDemoStore = (pinia: Pinia, hot?: StoreGeneric) => {
  return defineStore<string, DemoStep>("step-demo", () => {
    return initializeDemoStep(pinia);
  })(pinia, hot);
};
